import { Component, ViewChild } from "@angular/core";
import { Client } from "src/app/services/API/client";
import { toastrService } from "src/app/services/ux/toastr.service";
import { AddContractComponent } from "../../../common/components/modal/modal-add-contract-content/modal-add-contract-content.component";

@Component({
  templateUrl: "services-list.component.html"
})
export class ServicesListComponent {
  @ViewChild(AddContractComponent)
  private AddContractComponent: AddContractComponent;

  services: any;
  isLoading = false;
  selectedService: string;
  pershkrimi: string;
  targa: string;
  pershkrimidogan: string;
  pako: string;
  pershkrimoshee: string;
  nrkontrate: string;
  nrklienti: string;
  pershkrimuk: string;
  nrkontateuk: string;
  institutionCode: any;

  cities = [
    { city: "Tirane", cityCode: "UKT" },
    { city: "Divjake", cityCode: "UKDI" },
    { city: "Lushnje", cityCode: "UKLU" },
    { city: "Himare", cityCode: "UKHI" },
    { city: "Kukes", cityCode: "UKKU" },
    { city: "Mat", cityCode: "UKMA" },
    { city: "Roskovec", cityCode: "UKRV" },
    { city: "Kruje", cityCode: "UKKR" },
    { city: "Devoll", cityCode: "UKDV" },
    { city: "Kavaje", cityCode: "UKKV" },
    { city: "Shkoder", cityCode: "UKSH" },
    { city: "Elbasan", cityCode: "UKEL" },
    { city: "Pogradec", cityCode: "UKPG" },
    { city: "Fier", cityCode: "UKFR" },
    { city: "Korce", cityCode: "UKKO" },
    { city: "Shijak", cityCode: "UKSHI" },
    { city: "Vlore", cityCode: "UKVLORE" },
    { city: "Durres", cityCode: "UKD" }
  ];

  constructor(private client: Client, private toastr: toastrService) {
    this.getServices();
  }

  getServices() {
    this.isLoading = true;
    this.client
      .get("api/services")
      .then((res: any) => {
        this.services = res.filter((q: any) => q.isVisible === true);
        this.isLoading = false;
      })
      .catch((error) => {
        this.toastr.warning(error.error);
        this.isLoading = false;
      });
  }

  registerContract(service) {
    this.AddContractComponent.selectService(service);
  }
}
